export default __webpack_public_path__ + "static/RR_Custom-TC-3ef415729718ad6ffd73ca6b691713dd.woff";